import { render } from "./ReuniãoView.vue?vue&type=template&id=5dcee16f&scoped=true"
import script from "./ReuniãoView.vue?vue&type=script&lang=js"
export * from "./ReuniãoView.vue?vue&type=script&lang=js"

import "./ReuniãoView.vue?vue&type=style&index=0&id=5dcee16f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5dcee16f"]])

export default __exports__